
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheAsta extends Vue {
  @Prop() item!: any;
}
